/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".Card-title[_ngcontent-%COMP%]{margin-bottom:.5rem}"];
export { styles as styles };
